import {useAuth} from "@/stores/AuthStore";
import {storeToRefs} from "pinia";
export function requestAccess(to, from, next) {
    const {isAuthenticated, member} = storeToRefs(useAuth());

    if (isAuthenticated.value  && !member.value && to.name !== 'launchpad') {
        return next('/request-access');
    }
    return next();
}